import React from 'react';
const defaultContextValue = {
  // $FlowIgnore - this is populated via ContextWrapper
  location: {},
  // $FlowIgnore - this is populated via ContextWrapper
  history: {},
  // $FlowIgnore - this is populated via ContextWrapper
  match: {},
  staticContext: {}
};
export default /*#__PURE__*/React.createContext(defaultContextValue);